module.exports = __webpack_public_path__ + "img/sw-logo-lg.be543965.webp";